"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.quoteSummaryConfig = void 0;
var react_1 = __importDefault(require("react"));
var Text_1 = require("@CommonFrontend/ContentTokens/DataModels/Text");
var MakeConfig_1 = require("../Utils/MakeConfig");
var QuoteSummaryWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSummary/QuoteSummaryWidget");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var QuoteSummary_1 = __importStar(require("../../Widgets/QuoteSummary"));
var NormalizeVoidNode_1 = require("Project/QwilrEditor/Schemas/NormalizeVoidNode");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var WidgetActions_1 = require("Project/QwilrEditor/Behaviours/WidgetActions");
var TelemetryParameterValue_1 = require("@CommonFrontend/Telemetry/TelemetryParameterValue");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var createQuoteSummaryNode = function () { return ({
    type: "quoteSummary",
    children: [Text_1.text.createSlateJson()],
    isVoid: true,
    data: __assign({}, QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings),
}); };
exports.quoteSummaryConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("quoteSummary")), { node: {}, nodeType: "void", editorRender: QuoteSummary_1.default, toolbarButtons: QuoteSummary_1.QuoteSummaryToolbarButtons, serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        {
            subType: "quoteSummary",
            type: "block",
            showFeatureLists: node.data.showFeatureLists,
            showTextItems: node.data.showTextItems,
            showPlanSectionHeaders: node.data.showPlanSectionHeaders,
            compactLineItemDescriptions: node.data.compactLineItemDescriptions,
            compactSectionHeaders: node.data.compactSectionHeaders,
        }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function (token) {
        var _a, _b, _c, _d, _e;
        return ({
            type: "quoteSummary",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: {
                showFeatureLists: (_a = token.showFeatureLists) !== null && _a !== void 0 ? _a : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showFeatureLists,
                showTextItems: (_b = token.showTextItems) !== null && _b !== void 0 ? _b : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showTextItems,
                showPlanSectionHeaders: (_c = token.showPlanSectionHeaders) !== null && _c !== void 0 ? _c : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showPlanSectionHeaders,
                compactLineItemDescriptions: (_d = token.compactLineItemDescriptions) !== null && _d !== void 0 ? _d : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactLineItemDescriptions,
                compactSectionHeaders: (_e = token.compactSectionHeaders) !== null && _e !== void 0 ? _e : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactSectionHeaders,
            },
        });
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, validEditors: ["agreement"], validContainers: [], widgetAdderConfig: {
        tags: ["quote", "summary", "table", "total"],
        icon: react_1.default.createElement(icons_1.WidgetQuoteSummary, null),
        requiresFeatures: [FeatureFlag_1.default.AgreementViewWidget],
        displayName: "Quote summary",
    }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: createQuoteSummaryNode(),
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.QuoteSummary, width: "full-width" }));
